import { createContext } from 'react';

import { ApplicationsContextType } from './ApplicationsContext.types';

const initialContext: ApplicationsContextType = {
  addApplication: () => null,
  applications: [],
  removeApplication: () => null,
  setActiveApplication: () => null,
  updateApplication: () => null,
};

export const ApplicationsContext = createContext(initialContext);
